import { render, staticRenderFns } from "./ValueFromOption.vue?vue&type=template&id=9a6412f4&"
import script from "./ValueFromOption.vue?vue&type=script&lang=js&"
export * from "./ValueFromOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports